
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6 20a1 1 0 011-1h46a1 1 0 011 1v.89c0 7.071-4.366 13.201-10.825 16.743v2.55c0 .478-.187.938-.524 1.28a1.8 1.8 0 01-1.282.537H18.576a1.81 1.81 0 01-1.266-.54 1.834 1.834 0 01-.526-1.264V37.61c-5.001-2.754-8.74-7.062-10.16-12.155a.995.995 0 01-.11-.417A16.954 16.954 0 016 20.89V20zm2.897 5.995c1.504 4.175 4.812 7.748 9.256 10.08h23.694c4.444-2.332 7.752-5.905 9.256-10.08H8.897zm42.777-2H8.326A14.918 14.918 0 018 21h44a14.915 14.915 0 01-.326 2.995zm-10.5 14.08h-22.39V40h22.39v-1.924z"}})])
          )
        }
      }
    